import constantes, { level, parentFlag } from '../resources/constantes.json';
function parentLevelToIndex(nomenclator, eleccion, parentLevel, level, id) {
  const parent = nomenclator.ambitos[eleccion][id].p
    .map((p, index) => ({
      p,
      index,
    }))
    .filter(({ p }) => nomenclator.ambitos[eleccion][p].l === parentLevel)?.[0]
    ?.index;
  if (level < constantes.level.puesto) {
    return 0;
  }
  switch (parentLevel) {
    case constantes.level.comuna:
      return parent || 0;
    default:
      return 0;
  }
}

export default parentLevelToIndex;
